import { MenuListProps, components } from 'chakra-react-select';
import { CustomSelectGroupOptions, CustomSelectOption } from '../interfaces';

export const MenuList = ({
  children,
  ...props
}: MenuListProps<CustomSelectOption<any>, true, CustomSelectGroupOptions<any>>) => {
  return <components.MenuList {...props}>{children}</components.MenuList>;
};
